import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './image-block.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
class ImageBlock extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.transparent = false;
        this.landscape = false;
        this.carousel = false;
        this.fitImage = false;
        this.fullWidth = false;
        this.insideTextBlock = false;
        this.insideSocialProof = false;
    }
    firstUpdated() {
        const parent = this.parentNode;
        if ((parent === null || parent === void 0 ? void 0 : parent.tagName.toLowerCase()) === 'text-block')
            this.insideTextBlock = true;
        if ((parent === null || parent === void 0 ? void 0 : parent.tagName.toLowerCase()) === 'social-proof-item')
            this.insideSocialProof = true;
    }
    render() {
        var _a;
        return x `<div class="image-block ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''} ${this.alignment} ${this.fullWidth ? 'fullWidth' : ''} ${this.insideTextBlock ? 'insideTextBlock' : ''} ${this.insideSocialProof ? 'inside-social-proof' : ''} ${this.fitImage ? 'fit-image' : ''} ${this.transparent ? 'transparent' : ''} ${this.carousel ? 'carousel' : ''} ${this.rtl || isRTL() ? 'rtl' : ''}"><slot name="image"></slot><slot name="text"></slot></div>`;
    }
}
ImageBlock.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    n({ type: String })
], ImageBlock.prototype, "alignment", void 0);
__decorate([
    n({ type: Boolean })
], ImageBlock.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], ImageBlock.prototype, "transparent", void 0);
__decorate([
    n({ type: Boolean })
], ImageBlock.prototype, "landscape", void 0);
__decorate([
    n({ type: Boolean })
], ImageBlock.prototype, "carousel", void 0);
__decorate([
    n({ type: Boolean })
], ImageBlock.prototype, "fitImage", void 0);
__decorate([
    n({ type: Boolean })
], ImageBlock.prototype, "fullWidth", void 0);
__decorate([
    t()
], ImageBlock.prototype, "insideTextBlock", void 0);
__decorate([
    t()
], ImageBlock.prototype, "insideSocialProof", void 0);
customElements.define('image-block', ImageBlock);

export { ImageBlock };
